import { ApiEndpoint } from "@/app/apiEndpoint";
import axios from "@/app/http/axios";
import { FlightInfo } from "@/interface/FlightInfo.interface";

export default class FlightService {
  constructor() {}

  async getAllFlights() {
    const path = ApiEndpoint.Flight.PATH;
    try {
      const response = await axios.get<FlightInfo[]>(`${path}`, {
        headers: { "Content-Type": "application/json" },
      });
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async getFlightsWithConditions(filter: any) {
    const path = ApiEndpoint.Flight.PATH;
    try {
      const response = await axios.post<FlightInfo[]>(`${path}`, filter);
      return response;
    } catch (error: any) {
      throw error;
    }
  }
}
